import { BannerId } from '../../../typings/banners';
import { ValidationErrorData } from '../../../typings/common';
import { InternalResourceId } from '../../../typings/internalBanners';

export const SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR = 'SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR';
export type SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR = typeof SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR;
export interface ShowInternalBannerImageUploadError {
    type: SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    errors: ValidationErrorData[];
}
export function showInternalBannerImageUploadErrorAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    errors: ValidationErrorData[]
): ShowInternalBannerImageUploadError {
    return {
        type: SHOW_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR,
        bannerId,
        resourceId,
        errors
    };
}
